module.exports = __webpack_public_path__ + "60fccb0fd3d0d88b65303fa5598392c6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ticket_order_confirmation.svg
// module id = koPH
// module chunks = 5